<template>
  <el-select :ref="refs" style="width:100%" @focus="focus" v-model="id" :clearable="clearable" :allow-create="allowCreate" default-first-option :disabled="disabled" :multiple="multiple" filterable :placeholder="placeholder" remote
    :remote-method="remoteMethod" :loading="loading" @change="selectChange">
    <el-option label="未设置" value="0" v-if="showNone"></el-option>
    <el-option v-for="(item,index) in list" :key="index" :label="item.name" :value="item.id">
      <span :title="item.subjectCatalogueName" @click="optionClick">
        {{ item.name}}
        <small style="color:#bbb;" v-if="item.knowledgePointChildCount">（{{item.knowledgePointChildCount}}个子知识点）</small>
      </span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: "",
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
    defaults: {
      type: Array,
      default: () => { return [] }
    },
    subjectCatalogueId: {
      type: String,
      default: "",
    },
    defaultLoad: {
      type: Boolean,
      default: true,
    },
    showNone: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      list: [],
      id: "",
      loading: false,
      datas: [],
      placeholder: "请输入关键词搜索",
      isFirst: true,
    }
  },
  created() {
    this.refs = "professional_" + new Date().getTime();
    this.id = this.value == 0 ? "" : this.value;
    if (this.allowCreate) {
      this.placeholder = "请输入关键词搜索，按下Enter可以直接输入";
    }
  },
  mounted() {
    if (this.id) {
      this.remoteMethod();
    }
    if (this.defaults.length > 0) {
      this.setDatas();
    }
  },
  watch: {
    value: function (newValue) {
      this.id = newValue;
    },
    defaults() {
      this.setDatas();
    },
    subjectCatalogueId(val, oldVal) {
      this.isFirst = true;
      if (oldVal && oldVal != '0') {
        this.remoteMethod();
      }
    }
  },
  methods: {
    remoteMethod(key) {
      if (!this.subjectCatalogueId) {
        return;
      }
      this.loading = true;
      let params = {
        name: key,
        pageSize: 50,
        subjectCatalogueId: this.subjectCatalogueId,
      }
      this.list = [];
      this.https("get", "/api/KnowledgePoint/GetKnowledgePointListEasy", params).then(res => {
        this.loading = false;
        if (res.success) {
          this.list = res.response.data || [];
        }
        this.setDatas();
      }).catch(res => {
        this.loading = false;
      })
    },
    setDatas() {
      this.defaults.map(item => {
        let index = this.list.findIndex(list => list.id == item.id);
        if (index < 0) {
          this.list.push(item);
        }
      })
      this.list.map(item => {
        let index = this.datas.findIndex(list => list.id == item.id);
        if (index < 0) {
          this.datas.push(item);
        }
      })
    },
    selectChange(val) {
      if (this.multiple) {
        let datas = [];
        var items = this.func.depCopy(val);
        items.map(item => {
          let obj = this.datas.find(list => list.id == item);
          if (obj) {
            datas.push({
              id: obj.id,
              name: obj.name,
            })
          } else {
            datas.push({
              id: "",
              name: item,
            })
          }
        })
        this.$emit('input', val);
        this.$emit('change', datas);
      } else {
        this.$emit('input', val);
        let obj = this.list.find(item => val == item.id);
        this.$emit('change', obj);
      }
      if (val.length > 0) {
        setTimeout(() => {
          this.$refs[this.refs].blur();
        }, 50);
      }
    },
    focus() {
      if (this.isFirst) {
        this.remoteMethod();
        this.isFirst = false;
      }
    },
    optionClick() {

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/KnowledgeList.vue